import { ORDER_TYPE } from 'constants/trading';

export const AUTH_ORDER_TYPE = {
  BUY: ORDER_TYPE.BUY,
  SELL: ORDER_TYPE.SELL,
  AMEND_BUY: ORDER_TYPE.AMEND_BUY,
  AMEND_SELL: ORDER_TYPE.AMEND_SELL,
};

export const AUTH_MODAL_CONFIG = {
  real: {
    BUY: ORDER_TYPE.BUY,
    SELL: ORDER_TYPE.SELL,
    AMEND_BUY: ORDER_TYPE.AMEND_BUY,
    AMEND_SELL: ORDER_TYPE.AMEND_SELL,
  },
  virtual: {
    BUY: ORDER_TYPE.VIRTUAL_BUY,
    SELL: ORDER_TYPE.VIRTUAL_SELL,
    AMEND_BUY: ORDER_TYPE.VIRTUAL_AMEND_BUY,
    AMEND_SELL: ORDER_TYPE.VIRTUAL_AMEND_SELL,
  },
};
